


















import { Routes } from "@/router/routes";
import { Vue, Component } from "vue-property-decorator";
import PageHeader from "@/components/PageHeader.vue";

@Component({
  components: { PageHeader }
})
export default class Settings extends Vue {
  settings = [
    {
      name: "Dispositions",
      route: Routes.Dispositions
    },
    {
      name: "Products",
      route: Routes.Products
    },
    {
      name: "Message Templates",
      route: Routes.MessageTemplates
    },
    {
      name: "Blacklist",
      route: Routes.Blacklist
    }
  ];

  handleClick(item: any) {
    this.$router.push({ name: item.route });
  }
}
